// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuth, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // o un spinner
  if (!isAuth) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}
